import {
  Request,
  BaseApiUrl
} from "./api";

// 列表
export const getMatBalanceSubListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatBalanceSub/Get`, {
    params: params
  });
};

//新增
export const addMatBalanceSub = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatBalanceSub/Post`, params);
};

//重置当前结存
export const Recalculation = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatBalance/Recalculation`, params);
};

//获取详情
export const getMatBalanceSubDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatBalanceSub/Detail`, {
    params: params
  });
};